import React from 'react'
import { ComponentConfig } from '@puckeditor/core'
import { ColorField } from 'breaktime-theme/src/puck/fields/ColorField'
import PollArrow from 'images/inline/arrow-right-poll.svg'

export type PollNextQuestionButtonProps = {
  bgColor: string
  textColor: string
  bgHoverColor: string
  label?: string
}

export const POLL_NEXT_QUESTION_BUTTON_DEFAULT_PROPS: PollNextQuestionButtonProps = {
  bgColor: '#FFF',
  textColor: '#000',
  bgHoverColor: '#704FA0',
  label: 'Next Question',
}

export const PuckPollNextQuestionButton: ComponentConfig<PollNextQuestionButtonProps> = {
  label: 'Next Question Button',
  defaultProps: POLL_NEXT_QUESTION_BUTTON_DEFAULT_PROPS,
  permissions: {
    drag: false,
    duplicate: false,
    delete: false,
  },
  fields: {
    label: {
      type: 'text',
      label: 'Button Label',
    },
    bgColor: {
      type: 'custom',
      label: 'Button Background Color',
      render: (props: any) => <ColorField {...props} />,
    },
    textColor: {
      type: 'custom',
      label: 'Button Text Color',
      render: (props: any) => <ColorField {...props} />,
    },
    bgHoverColor: {
      type: 'custom',
      label: 'Button Background Hover Color',
      render: (props: any) => <ColorField {...props} />,
    },
  },
  render: ({ bgColor, textColor, bgHoverColor, label }) => (
    <div className="question-next-button-container">
      <button
        className="question-next-button is--active"
        style={{
          '--poll-next-question-button-bg-color': bgColor,
          '--poll-next-question-button-text-color': textColor,
          '--poll-next-question-button-bg-hover-color': bgHoverColor,
        } as React.CSSProperties}
      >
        {label || 'Next Question'} <PollArrow />
      </button>
    </div>
  ),
}
